import React from "react";
import type { Locale } from "./homepage-seo";
import { formatPaidAppPrice, paidAppCopy } from "./paid-app-pricing";

type Props = {
  locale: Locale;
  ready: boolean;
  pricingLabel: string;
  storeLabel: string;
  storeURL: string;
  quotaRows: Array<{ label: string; value: string }>;
  onStoreClick?: () => void;
};

/** Purchase information only: it neither signs in nor changes browser access. */
export function PaidAppPricingPanel({ locale, ready, pricingLabel, storeLabel, storeURL, quotaRows, onStoreClick }: Props) {
  const copy = paidAppCopy[locale];
  return (
    <section className="panel pricing-panel paid-app-pricing" aria-labelledby="paid-app-pricing-title">
      <div className="pricing-heading">
        <p className="eyebrow">Backtest · App Store</p>
        <h2 id="paid-app-pricing-title">{ready ? copy.title : pricingLabel}</h2>
        <p>{ready ? copy.body : copy.pendingBody}</p>
      </div>
      {ready && (
        <article className="price-card pro">
          <p className="eyebrow">Backtest Pro</p>
          <h3>{formatPaidAppPrice(locale)}</h3>
          <p className="billing-period">{copy.once}</p>
          <h4>{copy.limits}</h4>
          <dl className="paid-app-limits">
            {quotaRows.map(({ label, value }) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}
          </dl>
          <p className="billing-fine-print">{copy.priceNote}</p>
        </article>
      )}
      <a className="primary paid-app-store-link" href={storeURL} target="_blank" rel="noreferrer" onClick={onStoreClick}>
        {storeLabel}
      </a>
      {ready && (
        <div className="paid-app-questions">
          {(["account", "owners", "legacy"] as const).map((topic) => (
            <details className="trial-quota-note" key={topic}>
              <summary>{copy[`${topic}Title`]}</summary>
              <p>{copy[`${topic}Body`]}</p>
            </details>
          ))}
          <p className="billing-fine-print">{copy.webBody}</p>
        </div>
      )}
    </section>
  );
}
